'use client';

import { useEffect } from 'react';

const COOKIEBOT_ID = 'c0d24386-96e2-46f4-9770-7858bb722602';
const COOKIEBOT_SCRIPT_ELEMENT_ID = 'CookiebotScript';
const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]']);

export const CookiebotLoader = (): null => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Disable for localhost
    if (LOCAL_HOSTNAMES.has(window.location.hostname)) return;

    // Guard against duplicate injection: check both our own element ID and any
    // existing Cookiebot script (e.g. injected by a GTM container tag).
    if (
      document.getElementById(COOKIEBOT_SCRIPT_ELEMENT_ID) ||
      document.querySelector('script[src*="consent.cookiebot.com/uc.js"]')
    ) {
      return;
    }

    const script = document.createElement('script');
    script.id = COOKIEBOT_SCRIPT_ELEMENT_ID;
    script.src = 'https://consent.cookiebot.com/uc.js';
    script.async = true;
    script.setAttribute('data-cbid', COOKIEBOT_ID);
    script.setAttribute('data-blockingmode', 'auto');
    document.head.appendChild(script);
  }, []);

  return null;
};
